import { store } from '../../redux/store';
import { userIsAdmin } from '../../utils/globalFunctions';
import Service from '../Service';

export const getPlans = (params: { [key: string]: unknown }) => {
  const isAdmin = userIsAdmin(store.getState().loggedUser);
  const service = new Service({ route: '/paymentPlans', apiName: 'apiV2' });
  return service.get({ ...params, isAdmin });
};
